import { createSelector } from '@ngrx/store';
import { selectDecoratorsState } from './decorators.selector';

export const getPreviewContentLoaded = createSelector(
  selectDecoratorsState,
  (state): boolean => !!state.readonlyContent?.loaded
);
